module.exports = {"name":"@polkadot/wasm-crypto","version":"1.2.1","author":"Jaco Greeff <jacogr@gmail.com>","files":["crypto-polyfill.js","exports.js","index.d.ts","index.js","wasm.d.ts","wasm.js","wasm_asm.js","wasm_asm_stub.js","wasm_promise.js","wasm_wasm.js"],"react-native":{"./wasm_asm_stub.js":"./wasm_asm.js"},"main":"index.js","types":"index.d.ts","devDependencies":{"@polkadot/dev":"^0.50.8"},"peerDependencies":{"@polkadot/util":"*"}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@polkadot/wasm-crypto/package.json
// module id = 439
// module chunks = 0